<template>
  <div class="format-information">
    <custom-chip green-chip bold>
      <span>Leve {{ offer.take }} pague {{ offer.pay }}</span>
    </custom-chip>
    <span v-if="!isMobile" class="maximum-per-client-text"><strong>Máx. CPF: </strong>{{ offer.maximum_per_client }}</span>
  </div>
</template>

<script>
import CustomChip from '@/modules/industria/ofertas-trade/views/components/offer-schedule-list/CustomChip.vue'

export default {
  name: 'TakePayMechanic',
  components: {
    CustomChip,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.format-information {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;

  @media screen and (max-width: $xs-breakpoint) {
    align-items: center;
    gap: 8px;
  }

  .maximum-per-client-text {
    color: $cinza-0;
    font-size: 14px;
    margin-right: 6px;
  }
}
</style>
